// Definisci qui le rotte che non richiedono autenticazione
const PUBLIC_ROUTES = ["/login", "/register"]; // Aggiungi altre se necessario

/**
 * Controlla se un percorso è considerato pubblico (non richiede auth).
 * @param {string} path Il percorso da controllare (es. window.location.pathname)
 * @returns {boolean} True se il percorso è pubblico, altrimenti false.
 */
export const isPublicRoute = (path) => {
  // Controllo corrispondenza esatta
  if (PUBLIC_ROUTES.includes(path)) {
    return true;
  }
  // Controllo per sotto-rotte (es. /public/qualcosa) - Adatta se necessario
  // for (const route of PUBLIC_ROUTES) {
  //   if (path.startsWith(route + '/')) {
  //     return true;
  //   }
  // }
  return false;
};